import React, { Fragment ,useContext} from 'react'
import {Icon} from 'antd'
import {AppTableSearchContext} from 'qcc'

export class AppTableSearchCommon extends React.Component {

    render(){
        return (
        <div className='app-search-common'>
            <div style={{display:'flex'}}>
                {React.Children.toArray(this.props.children).map((child:any,index:number)=>{
                    return <div key={index} className='app-search-common-table-cell'> {child}</div>
                })}
                <MoreLink />
            </div>
        </div>)
    } 
}

const MoreLink = () =>{
    const {handleClickMore,existAdvanced,showMore}  = useContext(AppTableSearchContext)

    let text = showMore ? '收起筛选' : '展开筛选';
    let iconType = showMore ? 'up' : 'down';

    const renderMoreLink = () =>{
        return (
        <div className='app-search-common-more-link-content' onClick={handleClickMore}>
            <span className='more-link-span'>
				<span>{text}</span>
				<Icon className='more-link-icon' type={iconType}/>
			</span>
        </div>);
    }

    return existAdvanced ?renderMoreLink() :<Fragment />  ;
}


// WEBPACK FOOTER //
// ./src/qcc/AppTableSearch/AppTableSearchCommon.tsx